import React, { useEffect, useState } from "react";

import "../../Users/style.scss";

import "./style.css";
import "../RoleManagmentAndPermission/style.scss";
import { PackageList, configService, getPackageList } from "../../../utils/api";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "../../../utils/common";
import upiImg from "../../../assets/images/DMR.jpg";
import modalpopup from "../../../assets/images/modalPopubg.svg";
import { AlertWrapper } from "../../../Components/Modal/style";

import animationData1 from "../../../assets/lotties/question.json";
import Lottie from "react-lottie";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp";

const ServicesRoute = () => {
  const [isActive, setIsActive] = useState(false);
  const [drawerShow, setDrawerShow] = useState("");
  const [packageData, setPackageData] = useState([]);
  const [sevice, setService] = useState("");
  const [message, setMessage] = useState({});
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const [config,setConfirm] = useState(false);

  const handlePackage = (key) => {
    if (drawerShow === key) {
      setDrawerShow("");
    } else {
      setDrawerShow(key);
    }

    setIsActive((current) => !current);
  };

  const packageDetail = () => {
    getPackageList().then((resp) => {
      if (resp?.data?.success) setPackageData(resp?.data?.data);
    });
  };
  useEffect(() => {
    packageDetail();
  }, []);

  const changeService = (serviceName) =>{
    alert(serviceName)
    setConfirm("");
   configService(serviceName).then((resp) =>{
    if (resp?.data?.success === true) {
        setService(serviceName)
        setMessage({ msg: serviceName+" configure successfully.", type: "success" });

       
      } else {
        setLoading(false);
        let msg = "";
        if (resp?.data?.errorCodeList.length > 0) {
          msg = resp?.data?.errorCodeList[0];
        } else {
          msg = resp?.data?.msg;
        }
        setMessage({ msg: msg, type: "error" });
        
      }
   })
  }
  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };
  return (
    <>
     {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="transaction_main_container " style={{ padding: "30px" }}>
        <div className="transaction_head">
          <div className="transaction_heading" style={{ alignItems: "center" }}>
            <div className="transaction_left">
              <label>All Services</label>
            </div>
            {/* <div>
              <button onClick={handelCreate} className="userlist_btn">
                Create Package
              </button>
            </div> */}
          </div>
        </div>
  

        <div className="payment-cards">
          <Card title="UPI" icon={upiImg} sevice={sevice} setConfirm={setConfirm} />
        </div>
      </div>

      {!isEmpty(config) && (
          <ModalPopUp>
            <div
              className="modal-popup"
              style={{
                backgroundImage: `url(${modalpopup})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "right",
                backgroundPositionY: "bottom",
                height: "270px",
              }}
            >
              <div className="mt-20">
                <Lottie
                  options={defaultOptions1}
                  height={80}
                  width={80}
                ></Lottie>
              </div>

              <div className="flex justify-center ">
                <label className="fs25 blue_font fw-bold">Are you sure!</label>
              </div>
              <div className="flex justify-center">
                <label>You want to Change configure  ?</label>
              </div>
              <div className="flex justify-center gap-10 mt-30">
                <button
                  onClick={() => setConfirm("")}
                  className="cancel_button"
                >
                  No, Cancel it
                </button>
                <button
                  onClick={() => changeService(config)}
                  className="confirm_button"
                >
                  Yes, I am sure!
                </button>
              </div>
            </div>
          </ModalPopUp>
        )}
    </>
  );
};
export default ServicesRoute;


const Card = ({
  icon = "",
  title = "",
  setConfirm=() =>{},
  sevice="",
  Componant=""
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div
        className="payment-card"
      
      >
        <div className="flex justify-between">
          <div className="payment-logo" style={{ maxWidth: "40px" }}>
            {!isEmpty(icon) && <img src={icon} style={{ width: "100%" }}></img>}
            {!isEmpty(Componant) && <Componant />}
          </div>
          <div className="payment-title" style={{ fontWeight: "600" }}>
            {title}
          </div>
        </div>

        <div className="bottom-info w-100">
          <div className="flex justify-between align-items w-100">
            <div className="payment-count fs-12">
              <span style={{ color: "black" }}>Mobi Past : </span>
              </div>
            <div className="payment-count fs-12 ">
              <div
                className={`custom-toggle toggle_button ${(sevice ==="MOBIFAST") && "active"}`}
                style={{ margin: "0", marginRight: "12px" }}
                onClick={() => setConfirm("MOBIFAST")}
              >
                <div className="slider"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-info mt-5 ">
          <div className="flex justify-between align-items w-100">
            <div className="payment-count fs-12">
              <span style={{ color: "black" }}>Round Pay :</span>
             
            </div>
            <div className="payment-count fs-12">
              <div
                className={`custom-toggle toggle_button ${(sevice ==="ROUND_PAY") && "active"}`}
                style={{ margin: "0", marginRight: "12px" }}
                onClick={() => setConfirm("ROUND_PAY")}
              >
                <div className="slider"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
